import { Injectable } from "@angular/core";
import { IDeviceOptOut } from "@edp-models/device.model";
import { NotificationsService } from "@edp-services/notifications.service";
import { ELayoutActions, ShowLoader } from "@edp-store/actions/layout.actions";
import { ENotificationsActions, GetOptOut, RegisterDevice, SendOptOut, UpdatePushConfigs } from "@edp-store/actions/notifications.actions";
import { IAppState } from "@edp-store/state/app.state";
import { Actions, createEffect, Effect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { EMPTY } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";

@Injectable()
export class NotificationsEffects {
    sendOptOut$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ENotificationsActions.SendOptOut),
            switchMap((args: SendOptOut) => {
                this.store.dispatch(new ShowLoader(true));
                return this.notificationsService.sendOptOut(args.payload).pipe(
                    switchMap(() => [
                        { type: ENotificationsActions.SaveOptOut, payload: args.payload.pushState },
                        { type: ELayoutActions.ShowLoader, payload: false },
                    ]),
                    catchError(() => EMPTY)
                );
            })
        )
    );

    getOptOut$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ENotificationsActions.GetOptOut),
            switchMap((args: GetOptOut) => {
                this.store.dispatch(new ShowLoader(true));
                return this.notificationsService.getOptOut(args.payload).pipe(
                    switchMap((response: IDeviceOptOut) => [
                        { type: ENotificationsActions.SaveOptOut, payload: response.pushState },
                        { type: ELayoutActions.ShowLoader, payload: false },
                    ]),
                    catchError(() => EMPTY)
                );
            })
        )
    );

    registerDevice$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ENotificationsActions.RegisterDevice),
            switchMap((args: RegisterDevice) =>
                this.notificationsService.registerDevice(args.payload).pipe(
                    switchMap(() => {
                        localStorage.setItem("edp-device-info", JSON.stringify(args.payload));
                        return [{ type: ENotificationsActions.SaveDevice, payload: args.payload }];
                    }),
                    catchError(_error => EMPTY)
                )
            )
        )
    );

    @Effect()
    getPushConfigs$ = this.actions$.pipe(
        ofType(ENotificationsActions.GetPushConfigs),
        switchMap(() => {
            this.store.dispatch(new ShowLoader(true));

            return this.notificationsService.getPushConfigs().pipe(
                switchMap((response) => [
                    { type: ENotificationsActions.SetPushConfigs, payload: response },
                    { type: ELayoutActions.ShowLoader, payload: false }
                ]),
                catchError(_error => [
                    { type: ELayoutActions.ShowLoader, payload: false },
                    { type: ENotificationsActions.SetPushConfigs, payload: null }
                ])
            );
        })
    );

    @Effect()
    setPushConfigs$ = this.actions$.pipe(
        ofType(ENotificationsActions.UpdatePushConfigs),
        switchMap((action: UpdatePushConfigs) => {
            this.store.dispatch(new ShowLoader(true));

            return this.notificationsService.updatePushConfigs(action.payload).pipe(
                switchMap((response) => [
                    { type: ENotificationsActions.SetPushConfigs, payload: response },
                    { type: ELayoutActions.ShowLoader, payload: false }
                ]),
                catchError(_error => [
                    { type: ELayoutActions.ShowLoader, payload: false },
                    { type: ENotificationsActions.SetPushConfigs, payload: null }
                ])
            );
        })
    );

    constructor(private actions$: Actions, private notificationsService: NotificationsService, private store: Store<IAppState>) {}
}
